<template>
  <v-dialog v-model="dialog"     :fullscreen="$vuetify.display.smAndDown"
 max-width="800">
    <v-card>
      <v-card-actions class="redColor pa-0">
        <v-spacer />
        <v-btn class="ma-2" variant="outlined" icon @click="close">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="12" lg="12" class="mb-2">
            <!--LOADING-->
            <v-row v-if="loading" align="center" justify="center">
              <v-progress-circular indeterminate size="64" color="red" />
            </v-row>

            <!--EMPTY-->
            <v-row v-if="empty" class="mt-3 justify-center">
              <h3 class="text-red">
                {{ $t("repositories.shelf_content.empty") }}
              </h3>
            </v-row>
          </v-col>

          <!--PARTS-->
          <v-col v-if="!loading" cols="6" md="6" lg="6" class="pr-1">
            <!--COUNT-->
            <v-toolbar flat density="compact" class="bg-grey-lighten-4">
              <v-toolbar-title>
                {{ $t("repositories.shelf_content.parts") }}:
                <v-btn color="black" variant="outlined" size="small">
                  {{ parts.length }}
                </v-btn>
              </v-toolbar-title>
            </v-toolbar>
            <!-- PARTS LIST-->
            <v-list>
              <v-list-item
                v-for="(item, index) in parts"
                :key="index"
                class="listRowColor mb-1"
              >
                <v-list-item-title
                  class="d-flex align-start justify-start ga-2"
                >
                  <template v-if="item.old_id">
                    <span>{{
                      item.old_id.slice(
                        item.old_id.length - 6,
                        item.old_id.length,
                      )
                    }}</span>
                    <span
                      v-if="
                        item.infoCar &&
                        item.infoCar.description &&
                        item.infoCar.description.descriptionId &&
                        item.infoCar.description.descriptionId.title
                      "
                    >
                      -
                    </span>
                    <span>{{ multilanguage(item) }}</span>
                  </template>
                  <template v-else>
                    <span>{{
                      item._id.slice(item._id.length - 6, item._id.length)
                    }}</span>
                    <span
                      v-if="
                        item.infoCar &&
                        item.infoCar.description &&
                        item.infoCar.description.descriptionId &&
                        item.infoCar.description.descriptionId.title
                      "
                    >
                      -
                    </span>
                    <span>{{ multilanguage(item) }}</span>
                  </template>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-col>

          <!--EMPTY PARTS-->
          <v-col v-if="!loading" cols="6" md="6" lg="6" class="pl-1">
            <!--COUNT-->
            <v-toolbar flat density="compact" class="bg-grey-lighten-4">
              <v-toolbar-title>
                {{ $t("repositories.shelf_content.temporary_parts") }}:
                <v-btn color="black" variant="outlined" size="small">
                  {{ temporaryParts.length }}
                </v-btn>
              </v-toolbar-title>
            </v-toolbar>
            <!-- TEMPORARY PARTS LIST-->
            <v-list>
              <v-list-item
                v-for="(item, index) in temporaryParts"
                :key="index"
                class="listRowColor mb-1"
              >
                <v-list-item-title
                  class="d-flex align-start justify-start ga-2"
                >
                  <span>{{
                    item._id.slice(item._id.length - 6, item._id.length)
                  }}</span>
                  <span
                    v-if="
                      item.infoCar &&
                      item.infoCar.description &&
                      item.infoCar.description.descriptionId &&
                      item.infoCar.description.descriptionId.title
                    "
                  >
                    -
                  </span>
                  <span>{{ multilanguage(item) }}</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import getRequest from "../../api/getRequest";

export default {
  data: () => ({
    dialog: false,
    loading: false,
    empty: false,
    parts: [],
    temporaryParts: [],
  }),
  watch: {
    dialog(value) {
      if (!value) this.close();
    },
  },
  methods: {
    open(data) {
      this.dialog = true;
      this.getParts(data);
    },
    close() {
      this.empty = false;
      this.dialog = false;
      this.parts = [];
      this.temporaryParts = [];
      this.$emit("close");
    },
    getParts(data) {
      this.loading = true;
      getRequest("/repository/parts", `id=${data._id}`)
        .then((response) => {
          this.parts = response.parts;
          this.temporaryParts = response.temporaryParts;
          if (this.parts.length < 1 && this.temporaryParts.length < 1)
            this.empty = true;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    multilanguage(item) {
      if (
        item.infoCar &&
        item.infoCar.description &&
        item.infoCar.description.descriptionId &&
        item.infoCar.description.descriptionId.title
      ) {
        return item.infoCar.description.descriptionId.title[
          this.$store.getters.language
        ];
      }
      return "";
    },
  },
};
</script>
